import { styled } from '@mui/material';

import { I18nResources, useI18n } from '@app-velocity/i18n';

export type StatusProps = {
  status: 'ACTIVE' | 'PENDING' | 'EXPIRED';
};

const textByStatus: {[key: string]: I18nResources} = {
  ACTIVE: 'teams:invited.active',
  PENDING: 'teams:invited.pending_invite',
  EXPIRED: 'teams:invited.expired_invite',
};

const colorByStatus: {[key: string]: string} = {
  ACTIVE: 'var(--badge-active-text-color)',
  PENDING: 'var(--badge-pending-text-color)',
  EXPIRED: 'var(--badge-error-text-color)',
};

const backgroundByStatus: {[key: string]: string} = {
  ACTIVE: 'var(--badge-active-background-color)',
  PENDING: 'var(--badge-pending-background-color)',
  EXPIRED: 'var(--badge-error-background-color)',
};

const StyledStatus = styled('div')<{
  status: 'ACTIVE' | 'PENDING' | 'EXPIRED';
}>(({ theme, status }) => ({
  fontSize: 12,
  fontWeight: 300,
  borderRadius: theme.spacing(1),
  textAlign: 'center',
  padding: `${theme.spacing(1.5)} 0`,
  lineHeight: 1,
  backgroundColor: backgroundByStatus[status],
  color: colorByStatus[status]
}));

export const Status = ({ status }: StatusProps) => {
  const { t } = useI18n();

  const statusLabel = t(textByStatus[status])

  return <StyledStatus status={status}>{statusLabel}</StyledStatus>;
};
